import axios from 'axios';

import type {
  IUserDeleteUserDefaultContactParams,
  IUserDeleteUserDefaultContactRequest,
  IUserDeleteUserDefaultContactResponse,
} from '@/app-package';

const deleteUserDefaultContact = async (
  params: IUserDeleteUserDefaultContactParams,
) => {
  const config: IUserDeleteUserDefaultContactRequest = {
    url: `user/default/contact/delete/${params.userId}/${params.contactId}`,
    method: 'post',
  };

  const { data } =
    await axios.request<IUserDeleteUserDefaultContactResponse>(config);

  return data;
};

export default deleteUserDefaultContact;
